import {getPromoRows, getPromoTiles, getWrapper} from '../../helper';
import sortingBar from './sorting/sorting-bar';
import productResults from './product/product-results';
import loadMoreButton from './load-more-button';
import promoRows from './product/promo-rows';

/**
 * Mixes products with promo tiles.
 *
 * @param {Array<Object>} products - products
 * @param {Array<Object>} promoTiles - promo tiles
 */
const mixProductsWithPromoTiles = (products, promoTiles) => {
    let productsLength = products.length;

    for (let i = 0; i < promoTiles.length; i++) {
        const promoTile = promoTiles[i];
        if (promoTile.pos && productsLength >= promoTile.pos) {
            products.splice(promoTile.pos - 1, 0, promoTile);

            productsLength++;

            if (promoTile.width && promoTile.width === 2) {
                productsLength++;
            }
        }
    }
};

/**
 * @param {import('../../type-definitions').SearchResult} result - result
 * @returns {string} product grid HTML
 */
export default result => {
    if (!result) {
        return '';
    }

    const compareClass = getWrapper()?.dataset?.compareClass || '';
    const promoRowsData = getPromoRows();
    const promoTiles = getPromoTiles();

    if (promoTiles) {
        mixProductsWithPromoTiles(result.products, promoTiles);
    }

    return `
        <div class="search-result-wrapper">
            ${sortingBar(result)}
            <div class="xlt-searchresults search-result-content">
                ${promoRowsData ? promoRows(promoRowsData) : ''}
                <ul 
                    id="search-result-items" class="search-result-items tiles-container clearfix ${compareClass}"
                    ${result.isCategorySearch ? 'data-cnstrc-browse' : 'data-cnstrc-search'}
                    data-cnstrc-num-results="${result.numTotalResults}"
                >
                    ${productResults(result)}
                </ul>
                ${loadMoreButton(result)}
            </div>
        </div>
    `;
};
